(function () {
  'use strict';

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function normalizeId(value) {
    if (value == null) return '';
    var text = String(value);
    var match = text.match(/(\d+)(?:\D*)$/);
    return match ? match[1] : text;
  }

  function normalizeImageUrl(value) {
    if (!value || typeof value !== 'string') return '';
    try {
      var url = new URL(value, window.location.origin);
      return decodeURIComponent(url.pathname)
        .toLowerCase()
        .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?:_crop_[a-z]+)?(?=\.[a-z0-9]+$)/i, '');
    } catch (error) {
      return value.split('?')[0].toLowerCase();
    }
  }

  function imageCandidates(value) {
    if (!value) return [];
    if (typeof value === 'string') return [value];
    var candidates = [];
    ['src', 'url', 'original_src'].forEach(function (key) {
      if (value[key]) candidates.push(value[key]);
    });
    if (value.preview_image) candidates = candidates.concat(imageCandidates(value.preview_image));
    return candidates;
  }

  function readConfig(root) {
    var configEl = root.querySelector('[data-amp-config]');
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function selectedVariantId(root) {
    var input = root.querySelector('[data-variant-id]');
    return input ? normalizeId(input.value) : '';
  }

  function findVariant(source, variantId) {
    var variants = Array.isArray(source)
      ? source
      : (source && Array.isArray(source.variants) ? source.variants : []);

    return variants.find(function (variant) {
      return normalizeId(variant.id) === variantId;
    }) || null;
  }

  function variantMediaData(variant) {
    if (!variant) return { ids: [], urls: [] };

    var ids = [];
    var urls = [];
    var mediaValues = [variant.featured_media, variant.featured_image, variant.image].filter(Boolean);

    [variant.featured_media_id, variant.image_id].forEach(function (id) {
      if (id) ids.push(normalizeId(id));
    });

    mediaValues.forEach(function (media) {
      if (typeof media === 'object') {
        ['id', 'media_id', 'image_id'].forEach(function (key) {
          if (media[key]) ids.push(normalizeId(media[key]));
        });
      }
      urls = urls.concat(imageCandidates(media));
    });

    return {
      ids: ids.filter(Boolean),
      urls: urls.map(normalizeImageUrl).filter(Boolean)
    };
  }

  function mediaMatchesUrl(mediaEl, targets) {
    if (!targets.length) return false;
    return toArray(mediaEl.querySelectorAll('img')).some(function (image) {
      var sources = [
        image.currentSrc,
        image.src,
        image.getAttribute('src'),
        image.getAttribute('data-src')
      ].map(normalizeImageUrl).filter(Boolean);

      return sources.some(function (source) {
        return targets.some(function (target) {
          return source === target || source.endsWith(target) || target.endsWith(source);
        });
      });
    });
  }

  function activateVariantMedia(root, variant) {
    var data = variantMediaData(variant);
    if (!data.ids.length && !data.urls.length) return false;

    var mediaEls = toArray(root.querySelectorAll('.amp-gal__main .amp-media[data-media]'));
    var target = mediaEls.find(function (mediaEl) {
      var mediaId = normalizeId(mediaEl.getAttribute('data-media'));
      return data.ids.indexOf(mediaId) !== -1 || mediaMatchesUrl(mediaEl, data.urls);
    });

    if (!target) return false;

    var targetId = target.getAttribute('data-media');
    var thumb = toArray(root.querySelectorAll('.amp-thumb[data-media]')).find(function (button) {
      return normalizeId(button.getAttribute('data-media')) === normalizeId(targetId);
    });

    if (thumb) {
      thumb.click();
    } else {
      mediaEls.forEach(function (mediaEl) {
        mediaEl.classList.toggle('is-active', normalizeId(mediaEl.getAttribute('data-media')) === normalizeId(targetId));
      });
      toArray(root.querySelectorAll('.amp-thumb[data-media]')).forEach(function (button) {
        button.classList.toggle('is-active', normalizeId(button.getAttribute('data-media')) === normalizeId(targetId));
      });
    }

    toArray(root.querySelectorAll('.amp-lb__thumb[data-media]')).forEach(function (button) {
      button.classList.toggle('is-active', normalizeId(button.getAttribute('data-media')) === normalizeId(targetId));
    });

    return true;
  }

  function fetchProductJson(root) {
    if (root.__alfaProductJsonPromise) return root.__alfaProductJsonPromise;

    var endpoint = window.location.pathname.replace(/\/$/, '') + '.js';
    root.__alfaProductJsonPromise = fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product JSON unavailable');
      return response.json();
    }).catch(function () {
      return null;
    });

    return root.__alfaProductJsonPromise;
  }

  function syncVariantMedia(root) {
    var variantId = selectedVariantId(root);
    if (!variantId) return;

    var config = readConfig(root);
    var configuredVariant = findVariant(config && config.variants, variantId);
    if (activateVariantMedia(root, configuredVariant)) return;

    fetchProductJson(root).then(function (product) {
      var ajaxVariant = findVariant(product, variantId);
      activateVariantMedia(root, ajaxVariant);
    });
  }

  function scheduleSync(root) {
    [0, 30, 100, 250].forEach(function (delay) {
      window.setTimeout(function () { syncVariantMedia(root); }, delay);
    });
  }

  function init(root) {
    if (!root || root.dataset.alfaVariantMediaFix === 'ready') return;
    root.dataset.alfaVariantMediaFix = 'ready';

    root.addEventListener('click', function (event) {
      if (!event.target.closest('[data-opt-group] [data-opt]')) return;
      scheduleSync(root);
    });

    scheduleSync(root);
  }

  function initAll(scope) {
    var base = scope || document;
    var roots = [];

    if (base.nodeType === 1 && base.matches && base.matches('.alfa-main-product-section')) {
      roots.push(base);
    }

    if (base.querySelectorAll) {
      roots = roots.concat(toArray(base.querySelectorAll('.alfa-main-product-section')));
    }

    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target || document);
  });

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        toArray(mutation.addedNodes).forEach(function (node) {
          if (node && node.nodeType === 1) initAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
